export const MAX_GET_PARAM_LENGTH = 900

// Review
export const REVIEW_SOURCE_GOOGLE = 'GOOGLE'
export const REVIEW_SOURCE_WEBSITE = 'WEBSITE'
export const REVIEW_SOURCE_CUSTOM = 'CUSTOM'

export const REVIEW_RESPONSE_STATUS_CREATED = 'CREATED'
export const REVIEW_RESPONSE_STATUS_PENDING = 'PENDING'

export const MANUAL_REVIEW_RESPONSE_TYPE = 'MANUAL'
export const AUTOMATIC_REVIEW_RESPONSE_TYPE = 'AUTOMATIC'
export const APPROVAL_REVIEW_RESPONSE_TYPE = 'APPROVAL'

// Website Event
export const WEBSITE_EVENT_STATUS_REVIEWED = 'REVIEWED'
export const WEBSITE_EVENT_STATUS_UNREVIEWED = 'UNREVIEWED'

export const WEBSITE_EVENT_INPUT_TYPE_DATE = 'date'
export const WEBSITE_EVENT_INPUT_TYPE_TIME = 'time'
export const WEBSITE_EVENT_INPUT_TYPE_DATETIME_LOCAL = 'datetime-local'
export const WEBSITE_EVENT_INPUT_TYPE_TEXT = 'text'
export const WEBSITE_EVENT_INPUT_TYPE_SELECT = 'select'
export const WEBSITE_EVENT_INPUT_TYPE_MULTISELECT = 'multiSelect'
export const WEBSITE_EVENT_INPUT_TYPE_TEXTAREA = 'textarea'

// Provider
export const PROVIDER_GOOGLE = 'Google'

export const SERVICE_TYPE_LOCATION = 'Location'
export const SERVICE_TYPE_PROFILE = 'Profile'

export const PROVIDER_STATUS_ACTIVE = 'Complete'

// Component
export const FAST_ID_ANNOUNCEMENT = 'Announcement'
export const FAST_ID_CONTENT_MARKUP = 'Content.Markup'
export const FAST_ID_HEADER = 'Header'
export const FAST_ID_MARKDOWN_CONTENT = 'MarkdownContent'

// Simulation
export const SIMULATION_STATUS_PENDING = 'pending'
export const SIMULATION_STATUS_APPROVED = 'approved'
export const SIMULATION_STATUS_REJECTED = 'rejected'

// Simulation Component
export const SIMULATION_COMPONENT_REVIEW_STATUS_PENDING = 'pending'
export const SIMULATION_COMPONENT_REVIEW_STATUS_APPROVED = 'approved'
export const SIMULATION_COMPONENT_REVIEW_STATUS_REJECTED = 'rejected'

// Content Suggestions
export const CONTENT_SUGGESTION_TYPE_HEADER = 'HEADER'
export const CONTENT_SUGGESTION_TYPE_CONTENT = 'CONTENT'
export const CONTENT_SUGGESTION_TYPE_SEO_TITLE = 'SEO_TITLE'
export const CONTENT_SUGGESTION_TYPE_SEO_DESCRIPTION = 'SEO_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_CATEGORY_DESCRIPTION =
  'CATALOG_CATEGORY_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_CATEGORY_FULL_DESCRIPTION =
  'CATALOG_CATEGORY_FULL_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_CATEGORY_SEO_TITLE = 'CATALOG_CATEGORY_SEO_TITLE'
export const CONTENT_SUGGESTION_TYPE_CATALOG_CATEGORY_SEO_DESCRIPTION =
  'CATALOG_CATEGORY_SEO_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_ITEM_DESCRIPTION = 'CATALOG_ITEM_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_ITEM_FULL_DESCRIPTION =
  'CATALOG_ITEM_FULL_DESCRIPTION'
export const CONTENT_SUGGESTION_TYPE_CATALOG_ITEM_SEO_TITLE = 'CATALOG_ITEM_SEO_TITLE'
export const CONTENT_SUGGESTION_TYPE_CATALOG_ITEM_SEO_DESCRIPTION =
  'CATALOG_ITEM_SEO_DESCRIPTION'

// Website Page
export const RECIPE_NODE_PAGE_TYPE = 'RecipeNode'
export const EXTERNAL_PAGE_TYPE = 'External'
export const FAQ_PAGE_TYPE = 'FAQ'

// Question / FAQ
export const QUESTION_STATUS_ACTIVE = 'ACTIVE'
export const QUESTION_STATUS_UNDER_REVIEW = 'UNDER_REVIEW'
export const QUESTION_GROUP_NAME_DEFAULT_PROVIDED = 'Default Provided'

// Post
export const MERCHANT_POST_STATUS_DRAFT = 0
export const MERCHANT_POST_STATUS_PUBLISHED = 1

export const MERCHANT_POST_DESTINATION_BLOG = 'BLOG'
export const MERCHANT_POST_DESTINATION_GBP = 'GBP'

export const GBP_POST_STANDARD = 'STANDARD'
export const GBP_POST_OFFER = 'OFFER'

// GBP
export const GBP_CALL_TO_ACTION_TYPE_UNSPECIFIED = 'ACTION_TYPE_UNSPECIFIED'
export const GBP_CALL_TO_ACTION_TYPE_BOOK = 'BOOK'
export const GBP_CALL_TO_ACTION_TYPE_ORDER = 'ORDER'
export const GBP_CALL_TO_ACTION_TYPE_SHOP = 'SHOP'
export const GBP_CALL_TO_ACTION_TYPE_LEARN_MORE = 'LEARN_MORE'
export const GBP_CALL_TO_ACTION_TYPE_SIGN_UP = 'SIGN_UP'
export const GBP_CALL_TO_ACTION_TYPE_GET_OFFER = 'GET_OFFER'
export const GBP_CALL_TO_ACTION_TYPE_CALL = 'CALL'

export const MEDIA_FORMAT_PHOTO = 'PHOTO'
export const MEDIA_FORMAT_VIDEO = 'VIDEO'

export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_UNSPECIFIED = 'CATEGORY_UNSPECIFIED'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_COVER = 'COVER'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_PROFILE = 'PROFILE'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_LOGO = 'LOGO'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_EXTERIOR = 'EXTERIOR'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_INTERIOR = 'INTERIOR'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_PRODUCT = 'PRODUCT'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_AT_WORK = 'AT_WORK'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_FOOD_AND_DRINK = 'FOOD_AND_DRINK'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_MENU = 'MENU'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_COMMON_AREA = 'COMMON_AREA'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_ROOMS = 'ROOMS'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_TEAMS = 'TEAMS'
export const MEDIA_LOCATION_ASSOCIATION_CATEGORY_ADDITIONAL = 'ADDITIONAL'

// Merchant Category
export const MERCHANT_CATEGORY_RESTAURANT = 'REST'
export const MERCHANT_CATEGORY_SPA = 'SPA'
export const MERCHANT_CATEGORY_SALON = 'SALON'
export const MERCHANT_CATEGORY_HAIR_CARE = 'HAIR'
export const MERCHANT_CATEGORY_TATTOO_PARLOR = 'TATTOO PARLOR'
export const MERCHANT_CATEGORY_BUSINESS = 'BUSINESS'
export const MERCHANT_CATEGORY_ENTERTAINMENT = 'ENTERTAINMENT'
export const MERCHANT_CATEGORY_BARBERSHOP = 'BARBER'
export const MERCHANT_CATEGORY_SKIN_CARE = 'SKIN'
export const MERCHANT_CATEGORY_NAIL_CARE = 'NAIL'
export const MERCHANT_CATEGORY_MAKEUP = 'MAKEUP'

export const ONBOARDING_BLUEPRINT_STATUS_NOT_APPLICABLE = 'not_applicable'
export const ONBOARDING_BLUEPRINT_STATUS_READY = 'ready'
export const ONBOARDING_BLUEPRINT_STATUS_SUBMITTED = 'submitted'
export const ONBOARDING_BLUEPRINT_STATUS_ERROR = 'error'
